// import Continue from '../continue';
import CancelOrder from '../cancelOrder';
import Locked from '../lockedOrder';
import View from '../view';
import Continue from '../continue'

export const actionsRest = {
  INCOMPLETE: [CancelOrder],
  ORDER_VALIDATED: [Locked],
  PENDING_VALIDATION: [View],
  WAITING_ON_SALES: [View],
  ORDER_CANCELED: [Locked],
  CANCELED_BY_SALESREP:[Locked]
};
